/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { ApplicationConfig, ErrorHandler, provideZoneChangeDetection } from "@angular/core";
import { provideMomentDateAdapter } from "@angular/material-moment-adapter";
import { provideRouter } from "@angular/router";

import { registerLocaleData } from "@angular/common";
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import localeIt from "@angular/common/locales/it";
import { MAT_DATE_LOCALE, MAT_RIPPLE_GLOBAL_OPTIONS } from "@angular/material/core";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { flip, offset, shift } from "@ngx-popovers/core";
import { NGX_POPOVER_CONFIG, NgxPopoverConfig } from "@ngx-popovers/popover";
import { provideEcharts } from "ngx-echarts";
import { NGX_TIPPY_CONFIG } from "ngx-tippy-wrapper";
import echartsTheme from "../../public/config/echarts/theme.json";
import { routes } from "./app.routes";
import { GlobalictccErrorHandler } from "./shared/errors/globalictcc-error-handler.service";
import { httpInterceptor } from "./shared/interceptors/http.interceptor";

registerLocaleData(localeIt);

export const appConfig: ApplicationConfig = {
	providers: [
		{ provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: { disabled: true } },
		{
			provide: NGX_POPOVER_CONFIG,
			useValue: new NgxPopoverConfig({
				placement: "bottom-start",
				arrow: false,
				closeOnClickedOutside: false,
				middleware: [flip(), shift(), offset(30)]
			})
		},
		{
			provide: NGX_TIPPY_CONFIG,
			useValue: {
				arrow: false
			}
		},
		{ provide: MAT_DATE_LOCALE, useValue: "it-IT" },

		provideMomentDateAdapter(
			{
				parse: { dateInput: "DD/MM/YYYY" },
				display: {
					dateInput: "DD/MM/YYYY",
					monthYearLabel: "MM YYYY",
					dateA11yLabel: "DD/MM/YYYY",
					monthYearA11yLabel: "MMMM YYYY"
				}
			},
			{ useUtc: true }
		),
		provideZoneChangeDetection({ eventCoalescing: true }),
		provideRouter(routes),
		provideAnimationsAsync(),
		provideHttpClient(withInterceptors([httpInterceptor])),
		provideEcharts({ theme: echartsTheme }),

		{ provide: ErrorHandler, useClass: GlobalictccErrorHandler }
	]
};
